import { render, staticRenderFns } from "./ProjectCostsTable.vue?vue&type=template&id=6b7a2fc3"
import script from "./ProjectCostsTable.vue?vue&type=script&lang=ts"
export * from "./ProjectCostsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports